import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  showBackButton,
  onBackButtonClick,
  offBackButtonClick,
  hideBackButton,
  mountBackButton,
  unmountBackButton,
} from '@telegram-apps/sdk-react';
import { BottomNav } from '../../components/design/BottomNav';
import { BottomHint } from '../../components/design/BottomHint';
import { InlineCTA } from '../../components/design/InlineCTA';
import { StepIndicator } from '../../components/design/StepIndicator';
import { brand, fontFamily, tg } from '../../theme/tokens';
import { KISS_TYPES } from '../../data/kissTypes';
import { useWizard } from '../../state/wizard';

/** Step 3 — pick a kiss type (cheek/lips/french). */
export function KissTypeStep() {
  const navigate = useNavigate();
  const { scene, kissType: selectedType, setKissType } = useWizard();

  useEffect(() => {
    if (!scene) navigate('/wizard/scene', { replace: true });
  }, [scene, navigate]);

  useEffect(() => {
    try { mountBackButton(); showBackButton(); } catch { /* */ }
    const onBack = () => navigate('/wizard/scene');
    onBackButtonClick(onBack);
    return () => {
      offBackButtonClick(onBack);
      try { hideBackButton(); unmountBackButton(); } catch { /* */ }
    };
  }, [navigate]);

  return (
    <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', paddingBottom: 180 }}>
      <StepIndicator step={3} total={4} />

      <div style={{ padding: '6px 16px 14px', fontFamily }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: tg.text, letterSpacing: -0.4 }}>
          How they kiss
        </div>
        <div style={{ fontSize: 14, color: tg.textHint, marginTop: 4 }}>Pick the energy</div>
      </div>

      <div style={{ padding: '0 16px', display: 'flex', flexDirection: 'column', gap: 10, fontFamily }}>
        {KISS_TYPES.map((t) => {
          const on = selectedType === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setKissType(t.id)}
              style={{
                appearance: 'none',
                border: on ? `2px solid ${brand.solid}` : `1px solid ${tg.divider}`,
                borderRadius: 18,
                padding: '14px 16px',
                background: on ? `${brand.solid}10` : tg.bg2,
                display: 'flex',
                alignItems: 'center',
                gap: 14,
                boxShadow: on ? `0 6px 18px -4px ${brand.solid}33` : 'none',
                cursor: 'pointer',
                transition: 'border-color 200ms, background 200ms',
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  background: on ? brand.gradient : tg.bg3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 28,
                  flexShrink: 0,
                  boxShadow: on ? `0 6px 16px -3px ${brand.solid}55` : 'none',
                  transition: 'background 200ms, box-shadow 200ms',
                }}
              >
                {t.emoji}
              </div>
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div style={{ fontSize: 16, fontWeight: 700, color: tg.text }}>{t.name}</div>
                <div style={{ fontSize: 12, color: tg.textHint, marginTop: 2 }}>{t.description}</div>
              </div>
              {/* Radio circle — filled brand on selected, bordered ring otherwise.
                  Replaces the "from ⭐ X" label (pricing belongs to step 4). */}
              <div
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: 999,
                  border: on ? 'none' : `2px solid ${tg.divider}`,
                  background: on ? brand.solid : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  transition: 'background 200ms, border-color 200ms',
                }}
              >
                {on && (
                  <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                )}
              </div>
            </button>
          );
        })}
      </div>

      <div style={{ flex: 1 }} />

      {selectedType ? (
        <InlineCTA onClick={() => navigate('/wizard/duration')}>Continue</InlineCTA>
      ) : (
        <BottomHint>Pick a kiss type to continue</BottomHint>
      )}

      <BottomNav />
    </div>
  );
}
